import React from 'react';
import { Form } from 'react-bootstrap';
import InputMask from 'react-input-mask';

const ZipCodeInput = ({ label, name, register, errors, rules = {}, placeholder = "Digite o CEP" }) => {
  const zipCodeMask = '99999-999';

  const validateZipCode = (value) => {
    const numericValue = value.replace(/\D/g, '');
    if (numericValue.length === 0 || numericValue.length === 8) {
      return true;
    }
    return 'CEP inválido.';
  };

  return (
    <Form.Group controlId={name} className="mb-3">
      {label && <Form.Label className="mb-1">{label}</Form.Label>}
      <InputMask
        mask={zipCodeMask}
        maskChar={null}
        {...register(name, {
          ...rules,
          validate: validateZipCode,
        })}
        placeholder={placeholder}
        autoComplete='off'
      >
        {(inputProps) => (
          <Form.Control
            {...inputProps}
            className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
          />
        )}
      </InputMask>
      {errors[name] && <Form.Control.Feedback type="invalid">{errors[name].message}</Form.Control.Feedback>}
    </Form.Group>
  );
};

export default ZipCodeInput;